import * as Yup from "yup";
import { cpf as cpfTest } from "cpf-cnpj-validator";

const regex = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;

export const stepOneSchema = Yup.object().shape({
    nome: Yup.string()
        .required("O nome é obrigatório")
        .transform((v) => (typeof v === "string" ? v.replace(/\s+/g, " ").trim() : v))
        .min(3, "O nome deve ter no mínimo 3 letras")
      .max(100, "O nome deve ter no máximo 100 letras")
        .matches(regex, "O nome deve ter apenas letras e espaços")
        .test("has-surname", "O nome deve ter no mínimo nome e sobrenome", (value) => {
            if (typeof value !== "string") return false;
            const partes = value.split(" ").filter(Boolean);
            return partes.length >= 2;
        }),

  email: Yup.string()
    .required("O email é obrigatório")
    .min(3, "O email deve ter no mínimo 3 letras")
    .max(60, "O email deve ter no máximo 60 letras")
    .email("O email deve ser um endereço de email válido"),
  confirmEmail: Yup.string()
    .required("Confirmar o email é obrigatório")
    .min(3, "O email deve ter no mínimo 3 letras")
    .max(60, "O email deve ter no máximo 60 letras")
    .email("O email deve ser um endereço de email válido")
    .oneOf(
      [Yup.ref("email"), null],
      "Os e-mails devem combinar em ambos os campos"
    ),
  cpf: Yup.string()
    .required("O CPF é obrigatório")
    .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, "O CPF deve ser um número válido")
    .test("cpf", "O CPF deve ser válido", (value: any) => {
      if (value) {
        return cpfTest.isValid(value);
      }
      return false;
    }),
  telefone: Yup.string()
    .required("O celular é obrigatório")
    .matches(
      /^\(\d{2}\)\d{5}-\d{4,6}$/,
      "O telefone deve ser um número válido no formato (99)99999-9999"
    ),

  cidade: Yup.string()
    .required("A cidade é obrigatória")
    .transform((v) => (typeof v === "string" ? v.replace(/\s+/g, " ").trim() : v))
    .min(3, "A cidade deve ter no mínimo 3 letras")
    .max(60, "A cidade deve ter no máximo 60 letras")
    .matches(regex, "A Cidade deve ter apenas letras e espaços"),

  dataNascimento: Yup.string()
    .required("A data de nascimento é obrigatória")
    .matches(/^\d{4}-\d{2}-\d{2}$/, "Use AAAA-MM-DD")
    .test("range-idade", "Idade deve estar entre 16 e 100 anos", (v) => {
      if (!v) return false;

      const hoje = new Date();
      const iso = (d: Date) => d.toISOString().slice(0, 10);

      const minNasc = "1925-01-01";
      const maxNasc = iso(new Date(hoje.getFullYear() - 16, hoje.getMonth(), hoje.getDate()));
      const minIdade = iso(new Date(hoje.getFullYear() - 100, hoje.getMonth(), hoje.getDate()));

      return v >= minIdade && v <= maxNasc && v >= minNasc;
    }),
  deficiencia: Yup.string().max(
    100,
    "O campo deve ter no máximo 100 caracteres"
  ),
});
